import { render, staticRenderFns } from "./ClientHistoryAppointments.vue?vue&type=template&id=60b81751&scoped=true"
import script from "./ClientHistoryAppointments.vue?vue&type=script&lang=js"
export * from "./ClientHistoryAppointments.vue?vue&type=script&lang=js"
import style0 from "./ClientHistoryAppointments.vue?vue&type=style&index=0&id=60b81751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b81751",
  null
  
)

export default component.exports